import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles((theme) => ({

  containButton: {
    '& > *': {
      margin: `5px 10px`,
    },
  },
  radios: {
    marginBottom:'20PX',
    display: 'block',
    '& .MuiFormControl-root':{
      '& .MuiFormLabel-root':{
        margin: '0 0 10px',
        color: '#263238',
        lineHeight: '25px',
      },
      flexDirection: 'column',
      '& .MuiFormGroup-row': {
        flexDirection: 'column',
      },
    }
  
  },
  tableContainer: {
    borderRadius: 4,
    border: 'solid 1px rgba(109, 114, 120, 0.18)',
    borderBottom: 'none',
  },
  titleCell: {
    width: '50%',
    fontWeight: 'bold',
  },
  titleCellData:{
    textAlign: 'right',

  },
  boldCell: {
    fontWeight: 'bold',
    fontSize: 14,
  },
  subTitleData: {
    fontSize: 12,
    marginTop: 0,
  },
  buttonProgress: {
    position: 'absolute',
    marginTop: '-45px',
    marginLeft: '9px',
  },
  radioItem: {
    border: '1px solid #90a4ae',
    backrgound: 'white',
    boxSizing: 'border-box',
    display: 'block',
    padding: theme.spacing(1, 2),
    marginInlineStart: 0,
    transition: 'ease .2s background',
    '&.active': {
      background: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
      color: 'white',
    },
    '&:first-child': {
      borderTopLeftRadius: 8,
      borderBottomLeftRadius: 8,
      borderRight: 'none',
    },
    '&:last-child': {
      borderTopRightRadius: 8,
      borderBottomRightRadius: 8,
      borderLeft: 'none',
    },
  },
  radioText: {
    color: '#2b3940',
    fontSize: 14,
    display: 'inline-block',
    transition: 'ease .2s color',
    fontWeight: 'bold',
    '&.active': {
      color: 'white',
    },
  },
  options: {
    '& label': {
      margin: 0,
    },
  },
  select: {
    backgroundColor: '#eceff1',
  },
  chip: {
    marginBottom: 8,
    marginInlineEnd: 5,
    backgroundColor: '#b3e5fc',
    '&:hover': {
      backgroundColor: '#8fcce8',
    },
  },
  chipLabel: { fontSize: 12 },
  errorMessage: {
    fontSize: '11px',
    color: 'red',
  },
  addVoucherWrapper: {
    marginTop: 30,
  },
  expandBtn: {
    border: `1px solid #2b3990`,
    padding: theme.spacing(2),
    margin: 0,
    background: 'white',
    color: '#2b3990',
    '&:hover': {
      background: '#2b3990',
      color: '#fff'
    }
  },
}));
